import React, {useCallback, useEffect, useState} from 'react';
import {CircuitList} from "../../../../components/admin/route/CircuitList";
import {ApiQueryParam, ApiService, filter, sort} from "../../../../service/ApiService";
import {circuitResultCollectionType, circuitResultType} from "../../../../types/Api/CircuitResultType";
import {circuitHydrator} from "../../../../models/hydrator/circuitHydrator";
import {circuit} from "../../../../models/circuit";
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {defaultPagination} from "../../../../types/PaginationType";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../../service/ToolsService";
import {Pagination} from "../../../../components/admin/Pagination";
import {Tab} from "../../../../components/admin/route/Tab";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState([] as filter[]);
  const [sort, setSort] = useState({by: 'label', direction: 'ASC'} as sort);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);
  const [circuits, setCircuits] = useState([] as circuit[]);

  const findCircuit = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    filter.forEach((f: filter) => {
      apiFilters.addFilter(f)
    })

    apiFilters.addSort(sort);
    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<circuitResultCollectionType> = ApiService.get('/circuit', apiFilters) as Promise<circuitResultCollectionType>;

    result
      .then((r: circuitResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setCircuits(r._embedded.circuits.map((circuit: circuitResultType) => {
          return circuitHydrator.hydrate(circuit);
        }));
      })
      .catch((e) => {
        console.log(e);
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setCircuits([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [count, page, filter, sort]);

  useEffect(() => {
    findCircuit();
  }, [findCircuit]);

  return (
    <>
      <BoxTitle title="Gestion des parcours"/>
      <Tab/>
      <CircuitList circuits={circuits} loading={loading} refresh={findCircuit} sort={sort}
                   filter={(filter: filter[]) => {
                     setFilter(filter)
                   }}
                   order={(s: string) => {
                     setSort({
                       by: s,
                       direction: (s !== sort?.by || sort.direction === 'DESC') ? 'ASC' : 'DESC'
                     })
                   }}
      />
      <p>
        {pagination.pageCount}
      </p>
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 text-end">
        <NavLink to={`/admin/route/circuit/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter un circuit
        </NavLink>
      </div>
    </>
  )
}
